<div class="user-allieds-wrapper">
  <div class="table-card">
    <div class="table-header">
      <p class="table-title alt-inter-semibold alt-size-18 alt-color-grayscale1">
        Lista de cuentas
      </p>
    </div>

    <div *ngIf="isLoading" class="empty-state alt-flex-column alt-justify-center">
      <p class="empty-title alt-inter-semibold alt-size-16 alt-color-grayscale1">
        Cargando cuentas...
      </p>
    </div>

    <div
      *ngIf="!isLoading && dataSource.length === 0"
      class="empty-state alt-flex-column alt-justify-center"
    >
      <p class="empty-title alt-inter-semibold alt-size-16 alt-color-grayscale1">
        No hay cuentas creadas todavía
      </p>
      <p class="empty-subtitle alt-inter-regular alt-size-14 alt-color-grayscale2">
        Aquí aparecerán las cuentas aliadas que se hayan creado en el sistema.
      </p>
    </div>

    <div *ngIf="!isLoading && dataSource.length > 0" class="users-list">
      <div class="user-card" *ngFor="let user of dataSource">
        <div class="user-card-left">
          <p class="user-email alt-inter-semibold alt-size-16 alt-color-grayscale1">
            {{ user.email }}
          </p>

          <p class="user-date alt-inter-regular alt-size-12 alt-color-grayscale2">
            Creado:
            {{ user.created_At | date : 'dd/MM/yyyy hh:mm a' }}
          </p>
        </div>

        <div class="user-card-right">
          <span
            class="role-badge alt-inter-medium alt-size-12"
            [ngClass]="getRoleClass(user.role)"
          >
            {{ user.role }}
          </span>

          <span
            class="status-badge alt-inter-medium alt-size-12"
            [ngClass]="getStatusClass(user.active)"
          >
            {{ user.active ? 'Activa' : 'Inactiva' }}
          </span>

          <button
            class="status-btn"
            mat-button
            type="button"
            [disabled]="processingUserId === user._id"
            (click)="toggleUserStatus(user)"
          >
            {{
              processingUserId === user._id
                ? 'Procesando...'
                : user.active
                ? 'Inhabilitar'
                : 'Habilitar'
            }}
          </button>
        </div>
      </div>
    </div>
  </div>
</div>